module.exports = __webpack_public_path__ + "static/media/jazzy-jeff.13d29945.jpg";